import React from "react";
import { Button, Form, Input } from "antd";
import {  useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";

function ConfirmOTP() {
  const location = useLocation();
  const email = location.state?.email || '';
  const dispatch = useDispatch();
  const navigate = useNavigate();



  //onFinish function for registration
  const onFinish = async (values) => {
    try {
      dispatch(showLoading());
      //post request to register user
      const response = await axios.post("/api/reset-Password/reset-password", values);
      dispatch(hideLoading());
      if (response.data.success) {
        //toast message
        toast.success(response.data.message);
        toast("change passcode successfully");
        navigate("/login");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  //return statement

  return (
    <div className="auth">
      <div className="auth-bg">
        <h1 className="card-t cn">Change Passcode</h1>
        <br></br>
        <div className="auth-form card p-3">
          <h3 className="card-title">Enter the OTP Code & Change Passcode</h3>
          <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="email" label="Email Address" initialValue={email}>
              <Input placeholder="Email Address " disabled />
            </Form.Item>

            <Form.Item
              name="otp"
              label="OTP Code"
              rules={[
                { type: "string", message: "The input is not a valid OTP Code!" },
                { required: true, message: "Please input your OTP Code!" },
              ]}
            >
              <Input placeholder="OTP Code" inputMode="numeric" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Passcode"
              rules={[
                { required: true, message: "Please input your passcode!" },
              ]}
            >
              <Input.Password placeholder="Passcode" />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="Confirm Passcode"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Please confirm your passcode!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("The two passcodes do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm Passcode" />
            </Form.Item>
            <Button className="btn-primary mt-3" htmlType="submit">
              Change Passcode
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ConfirmOTP;
